import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export const FieldIconWrapper = ({
  children,
  label,
  error,
  errorPrefix,
  iconRight,
  iconLeft,
  iconRightSize,
  iconRightSpin,
  iconLeftSize,
  iconLeftSpin,
  extraClassName,
  t = (arg) => arg,
}) => {
  const errorKeys = error ? Object.keys(error) : [];
  const hasError = errorKeys.length > 0;

  return (
    <div
      className={classnames(
        'form-group d-flex flex-row align-items-center',
        { 'has-danger': hasError },
        extraClassName
      )}
    >
      {label && <label className="form-control-label pr-2">{label}</label>}
      {iconLeft || iconRight ? (
        <div className="input-group">
          {iconLeft && (
            <span className="input-group-addon">
              <i
                className={classnames('fa', {
                  [`fa-${iconLeft}`]: !!iconLeft,
                  [`fa-${iconLeftSize}`]: !!iconLeftSize,
                  [`fa-spin`]: !!iconLeftSpin,
                })}
              />
            </span>
          )}
          {children}
          {iconRight && (
            <span className="input-group-addon">
              <i
                className={classnames('fa', {
                  [`fa-${iconRight}`]: !!iconRight,
                  [`fa-${iconRightSize}`]: !!iconRightSize,
                  [`fa-spin`]: !!iconRightSpin,
                })}
              />
            </span>
          )}
        </div>
      ) : (
        <div className="input-group">{children}</div>
      )}

      <small className="text-danger">
        {(hasError && t(`error.${errorPrefix ? `${errorPrefix}.` : ''}${errorKeys.shift()}`)) || ''}
        &nbsp;
      </small>
    </div>
  );
};

FieldIconWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.string,
  error: PropTypes.object,
  errorPrefix: PropTypes.string,
  iconRight: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRightSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconRightSpin: PropTypes.bool,
  iconLeftSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconLeftSpin: PropTypes.bool,
  extraClassName: PropTypes.string,
  t: PropTypes.func,
};

export default translate()(FieldIconWrapper);



// WEBPACK FOOTER //
// src/modules/common/components/form/FieldIconWrapper.js